import { useCallback } from "react";
import { toast } from "~/components/ui/toaster";

/**
 * Hook that provides a share function using native Web Share API on supported
 * devices (mobile), falling back to clipboard copy on desktop.
 */
export function useShare() {
  return useCallback(async (data: ShareData, successMessage = "Link copied to clipboard") => {
    try {
      if ("canShare" in navigator && "share" in navigator && navigator.canShare(data)) {
        await navigator.share(data);
        return;
      }

      // Fallback to clipboard
      if (data.url) {
        await navigator.clipboard.writeText(data.url);
      } else if (data.text) {
        await navigator.clipboard.writeText(data.text);
      } else if (data.title) {
        await navigator.clipboard.writeText(data.title);
      } else if (data.files) {
        await navigator.clipboard.write(data.files.map((f) => new ClipboardItem({ [f.type]: f })));
      }

      toast.success(successMessage);
    } catch (e) {
      // User cancelled share dialog - not an error
      if (e instanceof Error && e.name === "AbortError") {
        return;
      }
      toast.error("Failed to share");
    }
  }, []);
}
